export class Errors {
  errors: {[key: string]: string} = {};
}



// WEBPACK FOOTER //
// ./src/app/shared/models/errors.model.ts